<template>
    <div>
        <pixi-renderer :width="width" :height="height" ref="renderer">
            <container :x="0" :y="0">
                <sprite :x="0" :y="0" value="/assets/images/card.png"/>
                <qrcode :x="85" :y="345" :size="480" :value="qrcode"></qrcode>
                <pixi-text :x="320" :y="96" :value="name" :anchor=".5" fill="#000000" :fontSize="56"/>
            </container>
        </pixi-renderer>
    </div>
</template>

<script>
    import PixiRenderer from './PIXI/Renderer.vue'
    import Container from './PIXI/Container.vue'
    import Sprite from './PIXI/Sprite.vue'
    import Qrcode from './PIXI/QRcode.vue'
    import PixiText from './PIXI/Text.vue'

    export default {
        components: {
            PixiRenderer,
            Container,
            Sprite,
            Qrcode,
            PixiText,
        },

        props: [
            'qrcode',
            'name',
        ],

        data() {
            return {
                width: 640,
                height: 1493,
            }
        },

        methods: {
            download() {
                this.$refs.renderer.download();
            },

            print() {
                this.$refs.renderer.print();
            },
        }
    }
</script>
